"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash.assign"));
var _lodash2 = _interopRequireDefault(require("lodash.defer"));
var _LoggerUtils = require("./LoggerUtils");
var _browser = require("../utils/browser");
var _os = require("../utils/os");
require("whatwg-fetch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Module that provides the `Logger` class used for logging various events from
 * the `VideoPlayer`.
 *
 * @module Logger
 */
var LOGGING_URL = '/Logging/LogData';
var UNKNOWN_CLUSTER_LABEL = 'Unknown';
var LOAD_TIME = 'LoadTime';
var LOAD_TIME_LIMIT = 180000;

/**
 * Class for logging video player events.
 * @class Logger
 */
var Logger = exports["default"] = /*#__PURE__*/function () {
  /**
   * Creates an instance of the Logger.
   * @param {!string} loggerName - The name of the logger to be created
   * @param {!object} playerInstance - The video player instance
   */
  function Logger(loggerName, playerInstance) {
    var _this = this;
    _classCallCheck(this, Logger);
    _defineProperty(this, "_processAllLogs", function () {
      _this.sendCdnlessLogs();
      _this._processLogs();
    });
    _defineProperty(this, "_processLogs", function () {
      while (_this._queuedLogs.length > 0) {
        var logParams = _this._queuedLogs.shift();
        var url = _this._player.config.loggingDomain ? _this._player.config.loggingDomain + LOGGING_URL : LOGGING_URL;
        fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(logParams)
        })["catch"](function () {});
      }
    });
    /** @ignore */
    this._loggerName = loggerName;
    /** @ignore */
    this._player = playerInstance;
    /** @ignore */
    this._eventLogTimestamps = {};
    var playerConfig = playerInstance.config;
    var packageInfo = {
      name: playerConfig.packageName,
      version: playerConfig.packageVersion
    };
    if (typeof playerConfig.loggerCallback !== 'undefined') {
      /** @ignore */
      this._loggerCallback = playerConfig.loggerCallback;
    }

    /** @ignore */
    this._loggerInfo = {
      app: 'Hudl',
      op: 'VideoPlayback',
      browser: (0, _LoggerUtils.toSumoFormat)({
        name: (0, _browser.getName)(),
        version: (0, _browser.getVersion)()
      }),
      os: (0, _LoggerUtils.toSumoFormat)({
        name: (0, _os.getOSName)(),
        version: (0, _os.getOSVersion)()
      }),
      pageURL: window.location.href,
      cluster: UNKNOWN_CLUSTER_LABEL
    };
    (0, _LoggerUtils.getCluster)().then(function (cluster) {
      _this._loggerInfo.cluster = cluster || UNKNOWN_CLUSTER_LABEL;
    })["catch"](function () {
      console.error('Unable to fetch cluster'); //eslint-disable-line no-console
      _this._loggerInfo.cluster = UNKNOWN_CLUSTER_LABEL;
    });

    /** @ignore */
    this._libraryInfo = {
      playerName: playerInstance.name,
      playerVersion: playerInstance.version
    };
    if (packageInfo) {
      this._libraryInfo.libraryName = playerConfig.packageName;
      this._libraryInfo.libraryVersion = playerConfig.packageVersion;
    }

    /** @ignore */
    this._isSilent = !playerConfig.log;
    /** @ignore */
    this._cdnlessLogs = [];
    /** @ignore */
    this._queuedLogs = [];
    /** @ignore */
    this._logTimes = {};
    window.addEventListener('beforeunload', this._processAllLogs);
    window.addEventListener('unload', this._processAllLogs);
  }

  /**
   * Gets the logger times object.
   * @return {object} - The logger times object
   */
  return _createClass(Logger, [{
    key: "times",
    get: function get() {
      return this._logTimes;
    }

    /**
     * Sets the logger times object.
     * @param {object} data - The logger times object
     */,
    set: function set(data) {
      this._logTimes = data;
    }

    /**
     * Logs the time for a certain event type.
     * @param {string} event - The event type string
     * @param {number} time - The time to record
     */
  }, {
    key: "logTime",
    value: function logTime(event, time) {
      var now = Date.now();
      var throttleLimit = 500; // 500ms = 0.5s

      if (this._eventLogTimestamps[event] && now - this._eventLogTimestamps[event] < throttleLimit) {
        return; // Skip logging if within throttle limit
      }
      this._eventLogTimestamps[event] = now;
      if (event === LOAD_TIME && time > LOAD_TIME_LIMIT) {
        this.logIssue('LoadTimeOverLimit', {
          message: 'LoadTime over 3 minutes',
          loadTime: time
        });
      }
      var attributes = {
        videoEvent: (0, _LoggerUtils.toSumoFormat)(_defineProperty({}, event, Number(time.toFixed(2))))
      };
      this.sendLog({
        func: 'Timing',
        attributes: attributes
      });
    }

    /**
     * Logs the compatibility test case results.
     * @param {?object} info - The map of test cases to results for compatibility testing
     */
  }, {
    key: "logCompatibility",
    value: function logCompatibility(info) {
      this.sendLog({
        func: 'Compatibility',
        result: (0, _LoggerUtils.toSumoFormat)(info)
      });
    }

    /**
     * Logs the quality for a certain event type.
     * @param {string} event - The event type string
     * @param {?object} info - The object containing relevant logging information
     */
  }, {
    key: "logQuality",
    value: function logQuality(event, info) {
      this.sendLog({
        func: 'Quality',
        event: event,
        value: (0, _LoggerUtils.toSumoFormat)(info)
      });
    }

    /**
     * Logs any issue for a certain event type.
     * @param {string} event - The event type string
     * @param {?object} info - The object containing relevant logging information
     */
  }, {
    key: "logIssue",
    value: function logIssue(event, info) {
      this.sendLog({
        func: 'Issue',
        event: event,
        value: (0, _LoggerUtils.toSumoFormat)(info)
      });
    }
  }, {
    key: "sendCdnlessLogs",
    value: function sendCdnlessLogs() {
      while (this._cdnlessLogs.length > 0) {
        this.sendLog(this._cdnlessLogs.shift(), true);
      }
    }

    /**
     * Queues the logging event data and calls the processLogs method.
     * @param {object} data - The logging event data object
     * @private
     */
  }, {
    key: "sendLog",
    value: function sendLog(data) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this._player.cdnInfoFetched && !force) {
        this._cdnlessLogs.push(data);
        return;
      }
      var playerSrc = this._player.src;
      var videoInfo = {};
      if (typeof playerSrc !== 'undefined' && playerSrc !== null) {
        videoInfo.videoInfo = (0, _LoggerUtils.toSumoFormat)({
          videoType: (0, _LoggerUtils.getVideoType)(playerSrc),
          videoDuration: this._player.duration.toFixed(2),
          videoPath: playerSrc,
          CDN: this._player.cdnInfo
        });
      }
      var libraryInfo = {
        libraryInfo: this._libraryInfo
      };
      data.attributes = (0, _LoggerUtils.toSumoFormat)((0, _lodash["default"])({}, data.attributes, libraryInfo));
      var logData = (0, _lodash["default"])(videoInfo, this._loggerInfo, data);
      this._queuedLogs.push({
        loggerName: this._loggerName,
        message: '',
        data: (0, _LoggerUtils.toPascalCase)(logData)
      });
      if (typeof this._loggerCallback !== 'undefined') {
        this._loggerCallback(logData);
      } else if (!this._isSilent) {
        this.processLogs();
      }
    }

    /**
     * Processes the queue of logging events posting the data to the logging
     * endpoint (`/Logging/LogData`) on the server.
     * @private
     */
  }, {
    key: "processLogs",
    value: function processLogs() {
      (0, _lodash2["default"])(this._processLogs);
    }
  }]);
}();